<template>
  <header class="lowercase">[C:\dayjob\] {{ year }}> <slot /></header>
</template>

<script>
export default {
  name: 'WorkHeader',

  data() {
    const today = new Date()
    return {
      year: today.getFullYear()
    }
  }
}
</script>
